import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CompensationStatus, Namespace } from 'enums';
import { getSorter } from 'helpers';

export const useStatusesChipsGroup = (initialValues: CompensationStatus[] = []) => {
  const { t } = useTranslation(Namespace.CompensationStatuses);
  const [selectedStatuses, setSelectedStatuses] = useState<CompensationStatus[]>(initialValues);

  const statuses = useMemo(() => {
    return [
      CompensationStatus.Pending,
      CompensationStatus.Approved,
      CompensationStatus.Rejected,
      CompensationStatus.UpdateRequired,
      CompensationStatus.Closed,
      CompensationStatus.Failed,
    ]
      .map((status) => ({ value: status, label: t(status) }))
      .sort(getSorter(({ label }) => label));
  }, [t]);

  const mainStatuses = useMemo(() => {
    return [
      CompensationStatus.Pending,
      CompensationStatus.Approved,
      CompensationStatus.Rejected,
      CompensationStatus.Closed,
    ]
      .map((status) => ({ value: status, label: t(status) }))
      .sort(getSorter(({ label }) => label));
  }, [t]);

  return { statuses, mainStatuses, selectedStatuses, setSelectedStatuses };
};
